// Lib
import React from 'react';
import classNames from 'classnames';

// Utils
import { selectAllTextInput, selectAndCopyNode } from '../../../utils/domUtil';

// Components
import StyledPopupInputContainer from './StyledPopupInputContainer';
import SuccessTransitionButton from './SuccessTransitionButton';
import Spinner from '../../loaders/Spinner';

import './StaticURLField.scss';

type StaticURLFieldProps = {
    url: string;
    className?: string;
    buttonText?: string;
    buttonSuccessText?: string;
    children?: React.ReactNode;
    showSpinner?: boolean;
};

const StaticURLField = React.forwardRef<HTMLInputElement, StaticURLFieldProps>(function StaticURLField(
    {
        url,
        className,
        buttonText = 'Copy link',
        buttonSuccessText = 'Copied',
        showSpinner = false,
    }: StaticURLFieldProps,
    forwardedRef,
): React.ReactElement {
    const inputRef = React.useRef<HTMLInputElement | null>(null);

    const onCopy = () => {
        if (!inputRef || !inputRef.current) return;

        selectAndCopyNode(inputRef.current);
        inputRef.current.setSelectionRange(0, 0);
        inputRef.current.blur();
    };

    const assignRefs = (c: HTMLInputElement | null) => {
        if (!c) return;

        // Assign the input ref
        inputRef.current = c;

        // Assign the forwarded ref
        if (!forwardedRef) return;
        if (typeof forwardedRef === 'function') {
            forwardedRef(c);
        } else {
            forwardedRef.current = c;
        }
    };

    return (
        <StyledPopupInputContainer className="StaticURLField" readOnly>
            <input
                ref={assignRefs}
                className={classNames('static-url-input', className)}
                value={url}
                onFocus={selectAllTextInput}
                onClick={selectAllTextInput}
                readOnly
            />
            <SuccessTransitionButton className="solid" onClick={onCopy} successText={buttonSuccessText}>
                {showSpinner ? <Spinner show strokeWeightMultiplier={1.1} /> : buttonText}
            </SuccessTransitionButton>
        </StyledPopupInputContainer>
    );
});

export default StaticURLField;
